import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { PageBase, OrderCustomerModel, T4DataSource } from 't4core';
import { Router } from '@angular/router';
import { T4DatatableWidget } from '../../../../t4common';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  styleUrls: ['./Customers.css'],
  selector: 'Customers',
  templateUrl: './Customers.html',
})
export class Customers extends PageBase implements OnInit, AfterViewInit,OnDestroy {

  public isLoading: boolean = false;
  public showLoadCustomers: boolean = false;
  public onlyActive: boolean = true;
  public txtFilter: FormControl = new FormControl();
  public savedFilter: string = '';
  public showLoadCustomerByNumber = false;
  public customerNo: string = '';

  private filterSubscription: Subscription;

  @ViewChild("tblCustomers", { static: false }) tblCustomers: T4DatatableWidget;
  public customersData: OrderCustomerModel[] = [];

  constructor(el: ElementRef, private router: Router) {
    super(el, "TurboOrder");
  }

  async ngOnInit() {
    this.isLoading = true;

    //Gets the saved state before we do the api call to get the Customers.
    const savedshowOnlyActiveCustomer = localStorage.getItem('showOnlyActiveCustomers');
    if (savedshowOnlyActiveCustomer !== null) {
      this.onlyActive = JSON.parse(savedshowOnlyActiveCustomer);
    }

    this.customersData = await this.Api.get<OrderCustomerModel[]>("/TurboOrder/GetCustomers", { onlyActive: this.onlyActive });
    this.isLoading = false;
  }
  ngAfterViewInit() {
    const savedFilter = localStorage.getItem('customerListFilter');
    if (savedFilter) {
      this.tblCustomers.txtFilter.setValue(savedFilter, { emitEvent: false });
    }
    this.filterSubscription = this.tblCustomers.txtFilter.valueChanges.pipe(debounceTime(150))
      .subscribe((filterValue: string) => {
          localStorage.setItem('customerListFilter', filterValue);
        });
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }
  public async update() {
    this.isLoading = true;
    // this.tblCustomers.update();
    localStorage.setItem('showOnlyActiveCustomers', JSON.stringify(this.onlyActive));
    //Gets the data when we update the 'onlyActvie' state.
    this.customersData = await this.Api.get<OrderCustomerModel[]>("/TurboOrder/GetCustomers", { onlyActive: this.onlyActive });
    this.isLoading = false;
  }

  public gotoCustomer(customer: OrderCustomerModel) {
    this.router.navigateByUrl("/TurboOrder/Customer/" + customer.XalAccountNo);
  }
  public async GetCustomerFromAnata() {
    if (!this.customerNo?.trim()) {
      this.UI.alert("TO.Customer.CustomerNoRequired", "Customer number required", "TO.Customer.msgCustomerNoRequired","Please enter a customer number.");
      return;
    }

    this.isLoading = true;
    var result = await this.Api.get<OrderCustomerModel>("/TurboOrder/GetCustomersFromAnataById", { customerAccount: this.customerNo.trim() });
    if (result) {
      this.customersData = await this.Api.get<OrderCustomerModel[]>("/TurboOrder/GetCustomers", { onlyActive: this.onlyActive });

      this.customerNo = '';
      this.showLoadCustomerByNumber = false;
      this.UI.alert("TO.Customer.AnnataSuccess", "Customer retrieved from Annata", "TO.Customer.msgAnnataSuccess", "The customer is retrieved from Annata.")
    }
    else {
      this.UI.alert("TO.Customer.AnataFailed", "Failed!", "TO.Customer.msgAnataFailed", "The customer could not be retrieved.")
    }
    this.isLoading = false;
  }
}
